var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowToggleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40.0508,
    width: 40,
    height: 40,
    rx: 8,
    transform: "rotate(-179.927 40 40.0508)",
    fill: "#0A2024"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.0101,
    y: 32.0405,
    width: 24,
    height: 24,
    rx: 5,
    transform: "rotate(-179.927 32.0101 32.0405)",
    fill: "#101111"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0178 26.02L24.0254 20.0302L16.0331 14.02L16.0178 26.02Z",
    fill: "#23484E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToggleIcon);
export default __webpack_public_path__ + "static/media/ArrowToggleIcon.6644f98576f713d91e0613d8919d67e3.svg";
export { ForwardRef as ReactComponent };